import { getEnv } from '@core/config/CoreEnvironmentService';

export const isReadOnlyModeEnabled = (): boolean => getEnv().READ_ONLY;

export const resolveDefaultVault = (
  vaultIds?: string[] | undefined,
): string | null => {
  if (Array.isArray(vaultIds) && vaultIds.length > 0) {
    return vaultIds[0] ?? null;
  }

  return null;
};
